export default __webpack_public_path__ + "static/media/road5.0046ebcb.png";